// limit for crypto.getRandomValues()
const LIMIT_MAX_GEN_LEN = 0x10000;

const genAlphabetU8 = new TextEncoder().encode(
  "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"
);
const textDecoder = new TextDecoder();

export const genNanoidStream = (totalSize: number, len = 21) => {
  const totalGenLen = totalSize * len;
  let bufferLen = Math.min(
    LIMIT_MAX_GEN_LEN - (LIMIT_MAX_GEN_LEN % len),
    totalGenLen
  );
  let buf = new Uint8Array(bufferLen);
  crypto.getRandomValues(buf);
  for (let i = 0; i < bufferLen; i++) {
    buf[i] = genAlphabetU8[63 & buf[i]];
  }
  let s = textDecoder.decode(buf);
  let i = 0;
  let remainLen = totalGenLen;
  return () => {
    if (i + len > bufferLen) {
      remainLen -= i;
      if (remainLen - bufferLen < 0) {
        buf = buf.subarray(0, remainLen);
        bufferLen = remainLen;
      }
      crypto.getRandomValues(buf);
      for (let i = 0; i < bufferLen; i++) {
        buf[i] = genAlphabetU8[63 & buf[i]];
      }
      s = textDecoder.decode(buf);
      i = 0;
    }
    return s.slice(i, (i += len));
  };
};
